module.exports = __webpack_public_path__ + "img/icon_radius1.352bb35e.png";